import {useDialogContext} from "../../dialogs/hooks/useDialogContext";
import {ExportDataDialogState} from "../types/ExportDataDialogState";

export const useExportDataDialog = () => useDialogContext<ExportDataDialogState>('export-data')
